import axios from 'axios'
import qs from 'qs'
import baseApi from "./config"
import store from "@/store";
import {ElMessage} from "element-plus";
import { handleUnauthorized, isUnauthorizedResponse } from "./auth"
const ContentType = {
  JSON: 'application/json;charset=UTF-8',
  FORM: 'application/x-www-form-urlencoded;charset=UTF-8',
  UPLOAD: 'multipart/form-data'
}

const service = axios.create({
  baseURL: baseApi.host,
  timeout: 10000,
  headers: {
    'Content-Type': ContentType.JSON, // 设置默认请求头
  }
})

//创建存储 key 的 集合
let keyMap = new Map();

//获取每一次请求的key
function getRequestKey(config) {
  let { url, method, data, params } = config;
  //记得这里一定要处理 每次请求都掉会变化的参数(比如每个请求都携带了时间戳),否则二个请求的key不一样
  let key =  url + method
  return key;
}

//判断是否存在该key,不存在则插入
function checkRequest(config, source) {
  let key = getRequestKey(config);
  if (keyMap.has(key)) {
    source.cancel();
  } else {
    keyMap.set(key, config);
  }
}

//响应完成后,删除key
function deleteRequestKey(config) {
  let key = getRequestKey(config);
  if (keyMap.has(key)) {
    keyMap.delete(key);
  }
}
service.interceptors.request.use(
  config => {
    const source = axios.CancelToken.source();
    config.cancelToken = source.token
    const token=localStorage.getItem('token') || ''
    const {companyId}=JSON.parse(localStorage.getItem('companySelectItem')) || ''
    checkRequest(config, source)
    config.headers["Authorization"] = "Bearer " + token
    if (!config.headers["companyId"]) {
      config.headers["companyId"] = companyId
    }
    if(config.data) {
      if(config.headers["Content-Type"] === ContentType.FORM) {
        config.data = qs.stringify(config.data)
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    deleteRequestKey(response.config)
    if(response.headers["file-name"]) {
      return response
    }
    if(response.data.code != 200) {
      if(response.data.code == 401){
        handleUnauthorized(response.data.msg)
      } else {
        ElMessage.error(response.data.msg)
      }
    }
    return response.data || null
  },
  error => {
    if(axios.isCancel(error)){
      return new Promise(() => {})
    }
    if (isUnauthorizedResponse(error.response)) {
      handleUnauthorized(error.response?.data?.msg)
    }
    return Promise.reject(error.response)
  }
)

// ⭐ 创建 n8n webhook 专用的 axios 实例
const n8nService = axios.create({
  baseURL: baseApi.n8n,
  timeout: 10000,
  headers: {
    'Content-Type': ContentType.JSON,
  }
})

// n8n 请求拦截器（不需要 token 等认证）
n8nService.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// n8n 响应拦截器
n8nService.interceptors.response.use(
  response => {
    return response.data || null
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
export { n8nService }